import type { FunctionComponent } from 'react';

import { BUTTON_THEME_LEGACY, BUTTON_VARIANT_LEGACY, type CommonButtonProps } from './Button';
import { FakeButton } from '@/molecules/Buttons/FakeButton';

/**
 * @deprecated use Button with `component="span"` instead
 * @param props
 */
export const InertButton: FunctionComponent<CommonButtonProps> = (props) => {
  const opts = {
    ...props,
    ...(BUTTON_THEME_LEGACY[props.theme!] || {}),
    ...(BUTTON_VARIANT_LEGACY[props.variant!] || {}),
  };

  return (
    <FakeButton {...opts}>
      {opts.label}
      {props.children}
    </FakeButton>
  );
};

InertButton.displayName = 'InertButton';
